import classNames from "classnames";
import { FC } from "react";

import Modal from "components/Modal";

import WhatsAppVerificationContent from "./Content";

import styles from "./style.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  userId?: number;
  prefillPhone?: string;
};

const WidgetModalWhatsAppVerification: FC<PropTypes> = ({ isVisible, className, userId, prefillPhone }) => {
  return (
    <Modal
      title="WhatsApp verification"
      isClose
      isCloseBg
      isVisible={isVisible}
      className={classNames(styles.modal, className)}
    >
      <WhatsAppVerificationContent userId={userId} prefillPhone={prefillPhone} />
    </Modal>
  );
};

export default WidgetModalWhatsAppVerification;
